<template>
    <footer class="footer">
        <div>
<!--            鄂ICP备16000886号-7 Copyright © 2020 zb.zma-smart.com All rights reserved.-->
          Copyright © 2021 zma-smart.com All rights reserved.
            <p class="beian">
                <img src="../../assets/beian.png" alt="">
                鄂公网安备 42011602000548号
            </p>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'Footer'
}
</script>
<style lang="scss" scoped>
.footer{
    margin-top: 30px;
    width: 100%;
    min-width: 1200px;
    height: 40px;
    line-height: 40px;
    background: #35373D;
    div {
        width: 1200px;
        margin: 0 auto;
        line-height: 40px;
        color: #98A5C8;
        overflow: hidden;
        .beian{
            display: block;
            float: right;
            overflow: hidden;
            img {
                display: block;
                margin: 10px;
                float: left;
            }
        }
    }
}
</style>
